import React, { useEffect, useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Typography, Button, Modal } from "antd";
import Draggable from "react-draggable";
import OrderForm from "./OrderForm";
import { CloseOutlined } from "@ant-design/icons";
import { FormattedMessage } from "react-intl";
import { reset } from "./OrderDetailsSlice";
import { useDispatch } from "react-redux";
import useOrderState from "./useOrderState";
import { loadPage } from "../orders/OrdersSlice";

const { Title } = Typography;

const Order = (props) => {
  const { type, onHide, onConfirm, selectedOrder, visible } = props;
  const [form, setForm] = useState(null);
  const dispatch = useDispatch();

  const { disabled, toggleDraggable } = useOrderState(selectedOrder);

  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, [dispatch, visible]);

  const onDecline = useCallback(() => {
    onHide();
    dispatch(reset());
    form?.resetFields();
  }, [onHide]);

  const resetFormAndLoadData = () => {
    onHide();
    dispatch(reset());
    form?.resetFields();
    dispatch(loadPage({ current: 1 }));
  };

  return (
    <Modal
      afterClose={onDecline}
      destroyOnClose
      closable={false}
      maskClosable={false}
      footer={null}
      width="1200px"
      open={visible}
      onCancel={onHide}
      modalRender={(modal) => (
        <Draggable disabled={disabled}>{modal}</Draggable>
      )}
      title={null}
      forceRender
      style={{
        top: 10,
      }}
    >
      <div>
        <DraggableHeader
          onDecline={onDecline}
          toggleDraggable={toggleDraggable}
        />
        <Title level={2} style={{ textAlign: "center", marginBottom: 40 }}>
          {type === "edit" ? (
            <FormattedMessage id="app.orders.editOrder" />
          ) : type === "duplicate" ? (
            <FormattedMessage id="app.orders.duplicate" />
          ) : (
            <FormattedMessage id="app.orders.newOrder" />
          )}
        </Title>
        <OrderForm
          type={type}
          actionAfterSubmit={resetFormAndLoadData}
          selectedOrder={selectedOrder}
          onConfirm={onConfirm}
          setForm={(val) => setForm(val)}
        />
      </div>
    </Modal>
  );
};

const DraggableHeader = ({ onDecline, toggleDraggable }) => (
  <div
    style={{
      width: "100%",
      cursor: "move",
      height: "50px",
      position: "absolute",
      left: "0",
      top: "0",
    }}
    className="header"
    onMouseOver={toggleDraggable}
    onMouseOut={toggleDraggable}
  >
    <Button
      style={{ position: "absolute", left: 10, top: 10 }}
      className="closeBtn"
      type="text"
      shape="circle"
      icon={<CloseOutlined />}
      onClick={onDecline}
    />
  </div>
);

Order.propTypes = {
  onHide: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default Order;
